(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
(function (process){
; (function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define([], factory);
    } else if (typeof exports === 'object') {
        module.exports = factory();
    } else {
        root.browser = factory();
    }
}(this, function () {
    'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * @license almond 0.3.3 Copyright jQuery Foundation and other contributors.
 * Released under MIT license, http://github.com/requirejs/almond/LICENSE
 */
//Going sloppy to avoid 'use strict' string cost, but strict practices should
//be followed.
/*global setTimeout: false */

var requirejs, _require, define;
(function (undef) {
    var main,
        req,
        makeMap,
        handlers,
        defined = {},
        waiting = {},
        config = {},
        defining = {},
        hasOwn = Object.prototype.hasOwnProperty,
        aps = [].slice,
        jsSuffixRegExp = /\.js$/;

    function hasProp(obj, prop) {
        return hasOwn.call(obj, prop);
    }

    /**
     * Given a relative module name, like ./something, normalize it to
     * a real name that can be mapped to a path.
     * @param {String} name the relative name
     * @param {String} baseName a real name that the name arg is relative
     * to.
     * @returns {String} normalized name
     */
    function normalize(name, baseName) {
        var nameParts,
            nameSegment,
            mapValue,
            foundMap,
            lastIndex,
            foundI,
            foundStarMap,
            starI,
            i,
            j,
            part,
            normalizedBaseParts,
            baseParts = baseName && baseName.split("/"),
            map = config.map,
            starMap = map && map['*'] || {};

        //Adjust any relative paths.
        if (name) {
            name = name.split('/');
            lastIndex = name.length - 1;

            // If wanting node ID compatibility, strip .js from end
            // of IDs. Have to do this here, and not in nameToUrl
            // because node allows either .js or non .js to map
            // to same file.
            if (config.nodeIdCompat && jsSuffixRegExp.test(name[lastIndex])) {
                name[lastIndex] = name[lastIndex].replace(jsSuffixRegExp, '');
            }

            // Starts with a '.' so need the baseName
            if (name[0].charAt(0) === '.' && baseParts) {
                //Convert baseName to array, and lop off the last part,
                //so that . matches that 'directory' and not name of the baseName's
                //module. For instance, baseName of 'one/two/three', maps to
                //'one/two/three.js', but we want the directory, 'one/two' for
                //this normalization.
                normalizedBaseParts = baseParts.slice(0, baseParts.length - 1);
                name = normalizedBaseParts.concat(name);
            }

            //start trimDots
            for (i = 0; i < name.length; i++) {
                part = name[i];
                if (part === '.') {
                    name.splice(i, 1);
                    i -= 1;
                } else if (part === '..') {
                    // If at the start, or previous value is still ..,
                    // keep them so that when converted to a path it may
                    // still work when converted to a path, even though
                    // as an ID it is less than ideal. In larger point
                    // releases, may be better to just kick out an error.
                    if (i === 0 || i === 1 && name[2] === '..' || name[i - 1] === '..') {
                        continue;
                    } else if (i > 0) {
                        name.splice(i - 1, 2);
                        i -= 2;
                    }
                }
            }
            //end trimDots

            name = name.join('/');
        }

        //Apply map config if available.
        if ((baseParts || starMap) && map) {
            nameParts = name.split('/');

            for (i = nameParts.length; i > 0; i -= 1) {
                nameSegment = nameParts.slice(0, i).join("/");

                if (baseParts) {
                    //Find the longest baseName segment match in the config.
                    //So, do joins on the biggest to smallest lengths of baseParts.
                    for (j = baseParts.length; j > 0; j -= 1) {
                        mapValue = map[baseParts.slice(0, j).join('/')];

                        //baseName segment has  config, find if it has one for
                        //this name.
                        if (mapValue) {
                            mapValue = mapValue[nameSegment];
                            if (mapValue) {
                                //Match, update name to the new value.
                                foundMap = mapValue;
                                foundI = i;
                                break;
                            }
                        }
                    }
                }

                if (foundMap) {
                    break;
                }

                //Check for a star map match, but just hold on to it,
                //if there is a shorter segment match later in a matching
                //config, then favor over this star map.
                if (!foundStarMap && starMap && starMap[nameSegment]) {
                    foundStarMap = starMap[nameSegment];
                    starI = i;
                }
            }

            if (!foundMap && foundStarMap) {
                foundMap = foundStarMap;
                foundI = starI;
            }

            if (foundMap) {
                nameParts.splice(0, foundI, foundMap);
                name = nameParts.join('/');
            }
        }

        return name;
    }

    function makeRequire(relName, forceSync) {
        return function () {
            //A version of a require function that passes a moduleName
            //value for items that may need to
            //look up paths relative to the moduleName
            var args = aps.call(arguments, 0);

            //If first arg is not require('string'), and there is only
            //one arg, it is the array form without a callback. Insert
            //a null so that the following concat is correct.
            if (typeof args[0] !== 'string' && args.length === 1) {
                args.push(null);
            }
            return req.apply(undef, args.concat([relName, forceSync]));
        };
    }

    function makeNormalize(relName) {
        return function (name) {
            return normalize(name, relName);
        };
    }

    function makeLoad(depName) {
        return function (value) {
            defined[depName] = value;
        };
    }

    function callDep(name) {
        if (hasProp(waiting, name)) {
            var args = waiting[name];
            delete waiting[name];
            defining[name] = true;
            main.apply(undef, args);
        }

        if (!hasProp(defined, name) && !hasProp(defining, name)) {
            throw new Error('No ' + name);
        }
        return defined[name];
    }

    //Turns a plugin!resource to [plugin, resource]
    //with the plugin being undefined if the name
    //did not have a plugin prefix.
    function splitPrefix(name) {
        var prefix,
            index = name ? name.indexOf('!') : -1;
        if (index > -1) {
            prefix = name.substring(0, index);
            name = name.substring(index + 1, name.length);
        }
        return [prefix, name];
    }

    //Creates a parts array for a relName where first part is plugin ID,
    //second part is resource ID. Assumes relName has already been normalized.
    function makeRelParts(relName) {
        return relName ? splitPrefix(relName) : [];
    }

    /**
     * Makes a name map, normalizing the name, and using a plugin
     * for normalization if necessary. Grabs a ref to plugin
     * too, as an optimization.
     */
    makeMap = function (name, relParts) {
        var plugin,
            parts = splitPrefix(name),
            prefix = parts[0],
            relResourceName = relParts[1];

        name = parts[1];

        if (prefix) {
            prefix = normalize(prefix, relResourceName);
            plugin = callDep(prefix);
        }

        //Normalize according
        if (prefix) {
            if (plugin && plugin.normalize) {
                name = plugin.normalize(name, makeNormalize(relResourceName));
            } else {
                name = normalize(name, relResourceName);
            }
        } else {
            name = normalize(name, relResourceName);
            parts = splitPrefix(name);
            prefix = parts[0];
            name = parts[1];
            if (prefix) {
                plugin = callDep(prefix);
            }
        }

        //Using ridiculous property names for space reasons
        return {
            f: prefix ? prefix + '!' + name : name, //fullName
            n: name,
            pr: prefix,
            p: plugin
        };
    };

    function makeConfig(name) {
        return function () {
            return config && config.config && config.config[name] || {};
        };
    }

    handlers = {
        require: function (name) {
            return makeRequire(name);
        },
        exports: function (name) {
            var e = defined[name];
            if (typeof e !== 'undefined') {
                return e;
            } else {
                return defined[name] = {};
            }
        },
        module: function (name) {
            return {
                id: name,
                uri: '',
                exports: defined[name],
                config: makeConfig(name)
            };
        }
    };

    main = function (name, deps, callback, relName) {
        var cjsModule,
            depName,
            ret,
            map,
            i,
            relParts,
            args = [],
            callbackType = typeof callback === 'undefined' ? 'undefined' : _typeof(callback),
            usingExports;

        //Use name if no relName
        relName = relName || name;
        relParts = makeRelParts(relName);

        //Call the callback to define the module, if necessary.
        if (callbackType === 'undefined' || callbackType === 'function') {
            //Pull out the defined dependencies and pass the ordered
            //values to the callback.
            //Default to [require, exports, module] if no deps
            deps = !deps.length && callback.length ? ['require', 'exports', 'module'] : deps;
            for (i = 0; i < deps.length; i += 1) {
                map = makeMap(deps[i], relParts);
                depName = map.f;

                //Fast path CommonJS standard dependencies.
                if (depName === "require") {
                    args[i] = handlers.require(name);
                } else if (depName === "exports") {
                    //CommonJS module spec 1.1
                    args[i] = handlers.exports(name);
                    usingExports = true;
                } else if (depName === "module") {
                    //CommonJS module spec 1.1
                    cjsModule = args[i] = handlers.module(name);
                } else if (hasProp(defined, depName) || hasProp(waiting, depName) || hasProp(defining, depName)) {
                    args[i] = callDep(depName);
                } else if (map.p) {
                    map.p.load(map.n, makeRequire(relName, true), makeLoad(depName), {});
                    args[i] = defined[depName];
                } else {
                    throw new Error(name + ' missing ' + depName);
                }
            }

            ret = callback ? callback.apply(defined[name], args) : undefined;

            if (name) {
                //If setting exports via "module" is in play,
                //favor that over return value and exports. After that,
                //favor a non-undefined return value over exports use.
                if (cjsModule && cjsModule.exports !== undef && cjsModule.exports !== defined[name]) {
                    defined[name] = cjsModule.exports;
                } else if (ret !== undef || !usingExports) {
                    //Use the return value from the function.
                    defined[name] = ret;
                }
            }
        } else if (name) {
            //May just be an object definition for the module. Only
            //worry about defining if have a module name.
            defined[name] = callback;
        }
    };

    requirejs = _require = req = function (deps, callback, relName, forceSync, alt) {
        if (typeof deps === "string") {
            if (handlers[deps]) {
                //callback in this case is really relName
                return handlers[deps](callback);
            }
            //Just return the module wanted. In this scenario, the
            //deps arg is the module name, and second arg (if passed)
            //is just the relName.
            //Normalize module name, if it contains . or ..
            return callDep(makeMap(deps, makeRelParts(callback)).f);
        } else if (!deps.splice) {
            //deps is a config object, not an array.
            config = deps;
            if (config.deps) {
                req(config.deps, config.callback);
            }
            if (!callback) {
                return;
            }

            if (callback.splice) {
                //callback is an array, which means it is a dependency list.
                //Adjust args if there are dependencies
                deps = callback;
                callback = relName;
                relName = null;
            } else {
                deps = undef;
            }
        }

        //Support require(['a'])
        callback = callback || function () {};

        //If relName is a function, it is an errback handler,
        //so remove it.
        if (typeof relName === 'function') {
            relName = forceSync;
            forceSync = alt;
        }

        //Simulate async callback;
        if (forceSync) {
            main(undef, deps, callback, relName);
        } else {
            //Using a non-zero value because of concern for what old browsers
            //do, and latest browsers "upgrade" to 4 if lower value is used:
            //http://www.whatwg.org/specs/web-apps/current-work/multipage/timers.html#dom-windowtimers-settimeout:
            //If want a value immediately, use require('id') instead -- something
            //that works in almond on the global level, but not guaranteed and
            //unlikely to work in other AMD implementations.
            setTimeout(function () {
                main(undef, deps, callback, relName);
            }, 4);
        }

        return req;
    };

    /**
     * Just drops the config on the floor, but returns req in case
     * the config return value is used.
     */
    req.config = function (cfg) {
        return req(cfg);
    };

    /**
     * Expose module registry for debugging and tooling
     */
    requirejs._defined = defined;

    define = function (name, deps, callback) {
        if (typeof name !== 'string') {
            throw new Error('See almond README: incorrect module build, no module name');
        }

        //This module may not have dependencies
        if (!deps.splice) {
            //deps is not an array, so probably means
            //an object literal or factory function for
            //the value. Adjust args.
            callback = deps;
            deps = [];
        }

        if (!hasProp(defined, name) && !hasProp(waiting, name)) {
            waiting[name] = [name, deps, callback];
        }
    };

    define.amd = {
        jQuery: true
    };
})();

define("almond", function () {});

define('polyfills', [], function () {
    (function (method) {
        if (typeof method === 'undefined') {
            Object.assign = function (target, source) {
                var from;
                var to = target || {};
                var symbols;
                for (var s = 1; s < arguments.length; s++) {
                    from = Object(arguments[s]);
                    for (var key in from) {
                        if (Object.prototype.hasOwnProperty.call(from, key)) {
                            to[key] = from[key];
                        }
                    }
                    if (Object.getOwnPropertySymbols) {
                        symbols = Object.getOwnPropertySymbols(from);
                        for (var i = 0; i < symbols.length; i++) {
                            if (Object.prototype.propertyIsEnumerable.call(from, symbols[i])) {
                                to[symbols[i]] = from[symbols[i]];
                            }
                        }
                    }
                }
                return to;
            };
        }
    })(Object.assign);

    (function (method) {
        if (typeof method === 'undefined') {
            String.prototype.trim = function () {
                return String(this).replace(/^ +| +$/g, '');
            };
        }
    })(String.prototype.trim);

    (function (method) {
        if (typeof method === 'undefined') {
            Array.prototype.map = function (fn) {
                var rv = [];
                for (var i = 0, l = this.length; i < l; i++) {
                    rv.push(fn(this[i]));
                }return rv;
            };
        }
    })(Array.prototype.map);

    (function (method) {
        if (typeof method === 'undefined') {
            Array.prototype.filter = function (fn) {
                var rv = [];
                for (var i = 0, l = this.length; i < l; i++) {
                    if (fn(this[i])) rv.push(this[i]);
                }return rv;
            };
        }
    })(Array.prototype.filter);
});
var browsers = [['edge', /Edge\/([0-9\._]+)/], ['yandexbrowser', /YaBrowser\/([0-9\._]+)/], ['chrome', /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/], ['crios', /CriOS\/([0-9\.]+)(:?\s|$)/], ['firefox', /Firefox\/([0-9\.]+)(?:\s|$)/], ['opera', /Opera\/([0-9\.]+)(?:\s|$)/], ['opera', /OPR\/([0-9\.]+)(:?\s|$)$/], ['ie', /Trident\/7\.0.*rv\:([0-9\.]+)\).*Gecko$/], ['ie', /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/], ['ie', /MSIE\s(7\.0)/], ['bb10', /BB10;\sTouch.*Version\/([0-9\.]+)/], ['android', /Android\s([0-9\.]+)/], ['ios', /Version\/([0-9\._]+).*Mobile.*Safari.*/], ['safari', /Version\/([0-9\._]+).*Safari/]];

var os = ['Windows Phone', 'Android', 'CentOS', { 'name': 'Chrome OS', 'pattern': 'CrOS' }, 'Debian', 'Fedora', 'FreeBSD', 'Gentoo', 'Haiku', 'Kubuntu', 'Linux Mint', 'OpenBSD', 'Red Hat', 'SuSE', 'Ubuntu', 'Xubuntu', 'Cygwin', 'Symbian OS', 'hpwOS', 'webOS ', 'webOS', 'Tablet OS', 'Tizen', 'Linux', 'Mac OS X', 'Macintosh', 'Mac', 'Windows 98;', 'Windows '];

var osVersions = {
    '10.0': '10',
    '6.4': '10 Technical Preview',
    '6.3': '8.1',
    '6.2': '8',
    '6.1': 'Server 2008 R2 / 7',
    '6.0': 'Server 2008 / Vista',
    '5.2': 'Server 2003 / XP 64-bit',
    '5.1': 'XP',
    '5.01': '2000 SP1',
    '5.0': '2000',
    '4.0': 'NT',
    '4.90': 'ME'
};

function browserDetector(userAgent) {
    if (typeof userAgent === 'undefined') {
        if (typeof process !== 'undefined') {
            var version = process.version.slice(1).split('.').slice(0, 3);
            var versionTails = Array.prototype.slice.call(version, 1).join('') || '0';

            return {
                name: 'node',
                version: version.join('.'),
                versionNumber: parseFloat(version[0] + '.' + versionTails),
                mobile: false,
                os: process.platform
            };
        } else {
            throw 'Please give user-agent.\n' + '> browser(navigator.userAgent or res.headers[\'user-agent\']).';
        }
    }

    var result = {};

    Object.assign(result, browserDetector.browser(userAgent));
    Object.assign(result, browserDetector.mobile(userAgent));
    Object.assign(result, browserDetector.os(userAgent));

    return result;
};

browserDetector.browser = function (userAgent) {
    // * Referenced DamonOehlman/detect-browser
    return browsers.filter(function (element) {
        return element[1].test(userAgent);
    }).map(function (element) {
        var match = element[1].exec(userAgent);
        var version = match && match[1].split(/[._]/).slice(0, 3);
        var versionTails = Array.prototype.slice.call(version, 1).join('') || '0';

        if (version && version.length < 3) {
            Array.prototype.push.apply(version, version.length === 1 ? [0, 0] : [0]);
        }

        return {
            name: element[0],
            version: version.join('.'),
            versionNumber: parseFloat(version[0] + '.' + versionTails)
        };
    }).shift();
};

browserDetector.mobile = function (userAgent) {
    // * Referenced Mktg-Dept/detectmobilebrowsers
    return {
        mobile: /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(userAgent.substr(0, 4))
    };
};

browserDetector.os = function (userAgent) {
    // * Referenced bestiejs/platform.js
    return os.map(function (element) {
        return {
            name: element.name || element,
            pattern: element.pattern,
            value: RegExp('\\b' + (element.pattern || element.replace(/([ -])(?!$)/g, '$1?')) + '(?:/[\\d.]+|[ \\w.]*)', 'i').exec(userAgent)
        };
    }).filter(function (element) {
        return element.value;
    }).map(function (element) {
        var os = element.value[0];
        var osSurfix;

        if (element.pattern && element.name && /^Win/i.test(os) && !/^Windows Phone /i.test(os) && (osSurfix = osVersions[/[\d.]+$/.exec(os)])) {
            os = 'Windows ' + osSurfix;
        }

        if (element.pattern && element.name) {
            os = os.replace(RegExp(pattern, 'i'), element.name);
        }

        os = os.replace(/ ce$/i, ' CE').replace(/\bhpw/i, 'web').replace(/\bMacintosh\b/, 'Mac OS').replace(/_PowerPC\b/i, ' OS').replace(/\b(OS X) [^ \d]+/i, '$1').replace(/\bMac (OS X)\b/, '$1').replace(/\/(\d)/, ' $1').replace(/_/g, '.').replace(/(?: BePC|[ .]*fc[ \d.]+)$/i, '').replace(/\bx86\.64\b/gi, 'x86_64').replace(/\b(Windows Phone) OS\b/, '$1').replace(/\b(Chrome OS \w+) [\d.]+\b/, '$1').split(' on ')[0].trim();
        os = /^(?:webOS|i(?:OS|P))/.test(os) ? os : os.charAt(0).toUpperCase() + os.slice(1);

        return {
            os: os
        };
    }).shift();
};

define('browser-detect', ['polyfills'], function () {
    return browserDetector;
});
define('main', ['browser-detect'], function (browserDetect) {
    return function (_userAgent) {
        var userAgent;
        if (typeof _userAgent === 'undefined') {
            var navigator = typeof window !== 'undefined' ? window.navigator : navigator;
            if (typeof navigator === 'undefined') {
                userAgent = undefined;
            } else {
                userAgent = navigator.userAgent || navigator.vendor;
            }
        } else {
            userAgent = _userAgent;
        }
        return browserDetect(userAgent);
    };
});
    return _require('main');
}));
}).call(this,require('_process'))
},{"_process":4}],2:[function(require,module,exports){
/*
 * classList.js: Cross-browser full element.classList implementation.
 * 1.1.20170427
 *
 * By Eli Grey, http://eligrey.com
 * License: Dedicated to the public domain.
 *   See https://github.com/eligrey/classList.js/blob/master/LICENSE.md
 */

/*global self, document, DOMException */

/*! @source http://purl.eligrey.com/github/classList.js/blob/master/classList.js */

if ("document" in window.self) {

// Full polyfill for browsers with no classList support
// Including IE < Edge missing SVGElement.classList
if (!("classList" in document.createElement("_")) 
	|| document.createElementNS && !("classList" in document.createElementNS("http://www.w3.org/2000/svg","g"))) {

(function (view) {

"use strict";

if (!('Element' in view)) return;

var
	  classListProp = "classList"
	, protoProp = "prototype"
	, elemCtrProto = view.Element[protoProp]
	, objCtr = Object
	, strTrim = String[protoProp].trim || function () {
		return this.replace(/^\s+|\s+$/g, "");
	}
	, arrIndexOf = Array[protoProp].indexOf || function (item) {
		var
			  i = 0
			, len = this.length
		;
		for (; i < len; i++) {
			if (i in this && this[i] === item) {
				return i;
			}
		}
		return -1;
	}
	// Vendors: please allow content code to instantiate DOMExceptions
	, DOMEx = function (type, message) {
		this.name = type;
		this.code = DOMException[type];
		this.message = message;
	}
	, checkTokenAndGetIndex = function (classList, token) {
		if (token === "") {
			throw new DOMEx(
				  "SYNTAX_ERR"
				, "An invalid or illegal string was specified"
			);
		}
		if (/\s/.test(token)) {
			throw new DOMEx(
				  "INVALID_CHARACTER_ERR"
				, "String contains an invalid character"
			);
		}
		return arrIndexOf.call(classList, token);
	}
	, ClassList = function (elem) {
		var
			  trimmedClasses = strTrim.call(elem.getAttribute("class") || "")
			, classes = trimmedClasses ? trimmedClasses.split(/\s+/) : []
			, i = 0
			, len = classes.length
		;
		for (; i < len; i++) {
			this.push(classes[i]);
		}
		this._updateClassName = function () {
			elem.setAttribute("class", this.toString());
		};
	}
	, classListProto = ClassList[protoProp] = []
	, classListGetter = function () {
		return new ClassList(this);
	}
;
// Most DOMException implementations don't allow calling DOMException's toString()
// on non-DOMExceptions. Error's toString() is sufficient here.
DOMEx[protoProp] = Error[protoProp];
classListProto.item = function (i) {
	return this[i] || null;
};
classListProto.contains = function (token) {
	token += "";
	return checkTokenAndGetIndex(this, token) !== -1;
};
classListProto.add = function () {
	var
		  tokens = arguments
		, i = 0
		, l = tokens.length
		, token
		, updated = false
	;
	do {
		token = tokens[i] + "";
		if (checkTokenAndGetIndex(this, token) === -1) {
			this.push(token);
			updated = true;
		}
	}
	while (++i < l);

	if (updated) {
		this._updateClassName();
	}
};
classListProto.remove = function () {
	var
		  tokens = arguments
		, i = 0
		, l = tokens.length
		, token
		, updated = false
		, index
	;
	do {
		token = tokens[i] + "";
		index = checkTokenAndGetIndex(this, token);
		while (index !== -1) {
			this.splice(index, 1);
			updated = true;
			index = checkTokenAndGetIndex(this, token);
		}
	}
	while (++i < l);

	if (updated) {
		this._updateClassName();
	}
};
classListProto.toggle = function (token, force) {
	token += "";

	var
		  result = this.contains(token)
		, method = result ?
			force !== true && "remove"
		:
			force !== false && "add"
	;

	if (method) {
		this[method](token);
	}

	if (force === true || force === false) {
		return force;
	} else {
		return !result;
	}
};
classListProto.toString = function () {
	return this.join(" ");
};

if (objCtr.defineProperty) {
	var classListPropDesc = {
		  get: classListGetter
		, enumerable: true
		, configurable: true
	};
	try {
		objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
	} catch (ex) { // IE 8 doesn't support enumerable:true
		// adding undefined to fight this issue https://github.com/eligrey/classList.js/issues/36
		// modernie IE8-MSW7 machine has IE8 8.0.6001.18702 and is affected
		if (ex.number === undefined || ex.number === -0x7FF5EC54) {
			classListPropDesc.enumerable = false;
			objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
		}
	}
} else if (objCtr[protoProp].__defineGetter__) {
	elemCtrProto.__defineGetter__(classListProp, classListGetter);
}

}(window.self));

}

// There is full or partial native classList support, so just check if we need
// to normalize the add/remove and toggle APIs.

(function () {
	"use strict";

	var testElement = document.createElement("_");

	testElement.classList.add("c1", "c2");

	// Polyfill for IE 10/11 and Firefox <26, where classList.add and
	// classList.remove exist but support only one argument at a time.
	if (!testElement.classList.contains("c2")) {
		var createMethod = function(method) {
			var original = DOMTokenList.prototype[method];

			DOMTokenList.prototype[method] = function(token) {
				var i, len = arguments.length;

				for (i = 0; i < len; i++) {
					token = arguments[i];
					original.call(this, token);
				}
			};
		};
		createMethod('add');
		createMethod('remove');
	}

	testElement.classList.toggle("c3", false);

	// Polyfill for IE 10 and Firefox <24, where classList.toggle does not
	// support the second argument.
	if (testElement.classList.contains("c3")) {
		var _toggle = DOMTokenList.prototype.toggle;

		DOMTokenList.prototype.toggle = function(token, force) {
			if (1 in arguments && !this.contains(token) === !force) {
				return force;
			} else {
				return _toggle.call(this, token);
			}
		};

	}

	testElement = null;
}());

}

},{}],3:[function(require,module,exports){
/*! npm.im/object-fit-images 3.2.3 */
'use strict';

var OFI = 'bfred-it:object-fit-images';
var propRegex = /(object-fit|object-position)\s*:\s*([-\w\s%]+)/g;
var testImg = typeof Image === 'undefined' ? {style: {'object-position': 1}} : new Image();
var supportsObjectFit = 'object-fit' in testImg.style;
var supportsObjectPosition = 'object-position' in testImg.style;
var supportsOFI = 'background-size' in testImg.style;
var supportsCurrentSrc = typeof testImg.currentSrc === 'string';
var nativeGetAttribute = testImg.getAttribute;
var nativeSetAttribute = testImg.setAttribute;
var autoModeEnabled = false;

function createPlaceholder(w, h) {
	return ("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='" + w + "' height='" + h + "'%3E%3C/svg%3E");
}

function polyfillCurrentSrc(el) {
	if (el.srcset && !supportsCurrentSrc && window.picturefill) {
		var pf = window.picturefill._;
		// parse srcset with picturefill where currentSrc isn't available
		if (!el[pf.ns] || !el[pf.ns].evaled) {
			// force synchronous srcset parsing
			pf.fillImg(el, {reselect: true});
		}

		if (!el[pf.ns].curSrc) {
			// force picturefill to parse srcset
			el[pf.ns].supported = false;
			pf.fillImg(el, {reselect: true});
		}

		// retrieve parsed currentSrc, if any
		el.currentSrc = el[pf.ns].curSrc || el.src;
	}
}

function getStyle(el) {
	var style = getComputedStyle(el).fontFamily;
	var parsed;
	var props = {};
	while ((parsed = propRegex.exec(style)) !== null) {
		props[parsed[1]] = parsed[2];
	}
	return props;
}

function setPlaceholder(img, width, height) {
	// Default: fill width, no height
	var placeholder = createPlaceholder(width || 1, height || 0);

	// Only set placeholder if it's different
	if (nativeGetAttribute.call(img, 'src') !== placeholder) {
		nativeSetAttribute.call(img, 'src', placeholder);
	}
}

function onImageReady(img, callback) {
	// naturalWidth is only available when the image headers are loaded,
	// this loop will poll it every 100ms.
	if (img.naturalWidth) {
		callback(img);
	} else {
		setTimeout(onImageReady, 100, img, callback);
	}
}

function fixOne(el) {
	var style = getStyle(el);
	var ofi = el[OFI];
	style['object-fit'] = style['object-fit'] || 'fill'; // default value

	// Avoid running where unnecessary, unless OFI had already done its deed
	if (!ofi.img) {
		// fill is the default behavior so no action is necessary
		if (style['object-fit'] === 'fill') {
			return;
		}

		// Where object-fit is supported and object-position isn't (Safari < 10)
		if (
			!ofi.skipTest && // unless user wants to apply regardless of browser support
			supportsObjectFit && // if browser already supports object-fit
			!style['object-position'] // unless object-position is used
		) {
			return;
		}
	}

	// keep a clone in memory while resetting the original to a blank
	if (!ofi.img) {
		ofi.img = new Image(el.width, el.height);
		ofi.img.srcset = nativeGetAttribute.call(el, "data-ofi-srcset") || el.srcset;
		ofi.img.src = nativeGetAttribute.call(el, "data-ofi-src") || el.src;

		// preserve for any future cloneNode calls
		// https://github.com/bfred-it/object-fit-images/issues/53
		nativeSetAttribute.call(el, "data-ofi-src", el.src);
		if (el.srcset) {
			nativeSetAttribute.call(el, "data-ofi-srcset", el.srcset);
		}

		setPlaceholder(el, el.naturalWidth || el.width, el.naturalHeight || el.height);

		// remove srcset because it overrides src
		if (el.srcset) {
			el.srcset = '';
		}
		try {
			keepSrcUsable(el);
		} catch (err) {
			if (window.console) {
				console.warn('https://bit.ly/ofi-old-browser');
			}
		}
	}

	polyfillCurrentSrc(ofi.img);

	el.style.backgroundImage = "url(\"" + ((ofi.img.currentSrc || ofi.img.src).replace(/"/g, '\\"')) + "\")";
	el.style.backgroundPosition = style['object-position'] || 'center';
	el.style.backgroundRepeat = 'no-repeat';
	el.style.backgroundOrigin = 'content-box';

	if (/scale-down/.test(style['object-fit'])) {
		onImageReady(ofi.img, function () {
			if (ofi.img.naturalWidth > el.width || ofi.img.naturalHeight > el.height) {
				el.style.backgroundSize = 'contain';
			} else {
				el.style.backgroundSize = 'auto';
			}
		});
	} else {
		el.style.backgroundSize = style['object-fit'].replace('none', 'auto').replace('fill', '100% 100%');
	}

	onImageReady(ofi.img, function (img) {
		setPlaceholder(el, img.naturalWidth, img.naturalHeight);
	});
}

function keepSrcUsable(el) {
	var descriptors = {
		get: function get(prop) {
			return el[OFI].img[prop ? prop : 'src'];
		},
		set: function set(value, prop) {
			el[OFI].img[prop ? prop : 'src'] = value;
			nativeSetAttribute.call(el, ("data-ofi-" + prop), value); // preserve for any future cloneNode
			fixOne(el);
			return value;
		}
	};
	Object.defineProperty(el, 'src', descriptors);
	Object.defineProperty(el, 'currentSrc', {
		get: function () { return descriptors.get('currentSrc'); }
	});
	Object.defineProperty(el, 'srcset', {
		get: function () { return descriptors.get('srcset'); },
		set: function (ss) { return descriptors.set(ss, 'srcset'); }
	});
}

function hijackAttributes() {
	function getOfiImageMaybe(el, name) {
		return el[OFI] && el[OFI].img && (name === 'src' || name === 'srcset') ? el[OFI].img : el;
	}
	if (!supportsObjectPosition) {
		HTMLImageElement.prototype.getAttribute = function (name) {
			return nativeGetAttribute.call(getOfiImageMaybe(this, name), name);
		};

		HTMLImageElement.prototype.setAttribute = function (name, value) {
			return nativeSetAttribute.call(getOfiImageMaybe(this, name), name, String(value));
		};
	}
}

function fix(imgs, opts) {
	var startAutoMode = !autoModeEnabled && !imgs;
	opts = opts || {};
	imgs = imgs || 'img';

	if ((supportsObjectPosition && !opts.skipTest) || !supportsOFI) {
		return false;
	}

	// use imgs as a selector or just select all images
	if (imgs === 'img') {
		imgs = document.getElementsByTagName('img');
	} else if (typeof imgs === 'string') {
		imgs = document.querySelectorAll(imgs);
	} else if (!('length' in imgs)) {
		imgs = [imgs];
	}

	// apply fix to all
	for (var i = 0; i < imgs.length; i++) {
		imgs[i][OFI] = imgs[i][OFI] || {
			skipTest: opts.skipTest
		};
		fixOne(imgs[i]);
	}

	if (startAutoMode) {
		document.body.addEventListener('load', function (e) {
			if (e.target.tagName === 'IMG') {
				fix(e.target, {
					skipTest: opts.skipTest
				});
			}
		}, true);
		autoModeEnabled = true;
		imgs = 'img'; // reset to a generic selector for watchMQ
	}

	// if requested, watch media queries for object-fit change
	if (opts.watchMQ) {
		window.addEventListener('resize', fix.bind(null, imgs, {
			skipTest: opts.skipTest
		}));
	}
}

fix.supportsObjectFit = supportsObjectFit;
fix.supportsObjectPosition = supportsObjectPosition;

hijackAttributes();

module.exports = fix;

},{}],4:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],5:[function(require,module,exports){
'use strict';

/* Vendor */
require('./vendors/modernizr-3.5.0-custom.js');
require('./vendors/modernizr-additional-tests.js');

/* Polyfills */
require('classlist-polyfill');
require('./polyfills/object-fit-images');

/* Global */
require('./helpers.js');

/* Components */
require('./components/bodymovin-buttons.js');
require('./components/bodymovin-dots.js');
require('./components/sculpture.js');
require('./components/about-modal.js');
require('./components/browser-detection.js');
require('./components/smooth-scroll.js');
require('./components/year-counter-animation.js');
require('./components/article-modal.js');
require('./components/map_filters.js');
require('./components/map.js');

},{"./components/about-modal.js":6,"./components/article-modal.js":7,"./components/bodymovin-buttons.js":8,"./components/bodymovin-dots.js":9,"./components/browser-detection.js":10,"./components/map.js":11,"./components/map_filters.js":12,"./components/sculpture.js":13,"./components/smooth-scroll.js":14,"./components/year-counter-animation.js":15,"./helpers.js":16,"./polyfills/object-fit-images":17,"./vendors/modernizr-3.5.0-custom.js":18,"./vendors/modernizr-additional-tests.js":19,"classlist-polyfill":2}],6:[function(require,module,exports){
'use strict';

(function ($) {

    var $body = $('body');
    var $main = $body.children('main');
    var $modal = $body.find('#about-modal');
    var $background = $body.find('.about-modal-background');
    var $openButton = $body.find('#sculpture-container .question-button');
    var $closeButton = $modal.find('.close-button');

    var scrollPosition = undefined;

    function init() {
        bind();
    }

    function bind() {
        $openButton.on('click', openModal);
        $closeButton.on('click', closeModal);
    }

    function openModal(event) {
        if (!event) {
            return false;
        }
        event.preventDefault();
        scrollPosition = $(document).scrollTop();
        $body.addClass('about-modal-open');
        $main.addClass('unfold-animation-in');
        $background.addClass('unfold-animation-in');
        $modal.addClass('unfold-animation-in');
        $main.css('top', -1 * scrollPosition);
    }

    function closeModal(event) {
        if (!event) {
            return false;
        }
        event.preventDefault();
        $modal.addClass('unfold-animation-out');
        $background.addClass('unfold-animation-out');
        $main.addClass('unfold-animation-out');
        $main.css('top', '');
        $(document).scrollTop(scrollPosition);

        setTimeout(function () {
            $body.removeClass('about-modal-open');
            $modal.removeClass('unfold-animation-in unfold-animation-out');
            $main.removeClass('unfold-animation-in unfold-animation-out');
            $background.removeClass('unfold-animation-in unfold-animation-out');
        }, 1000);
    }

    init();
})(jQuery);

},{}],7:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* TODO:
    handle new $modal.toggleClass('about-modal-open');
*/

(function ($) {
    var $body = $('body');
    var $modal = $body.children('#article-modal');
    var $modalBackground = $body.children('.article-modal-background');

    if ($modal.length === 0) {
        return false;
    }

    var $closeToggle = $modal.find('.close-button');
    var $aboutToggle = $modal.find('.question-button');
    var $aboutModal = $modal.find('.about-modal');
    var $prevButton = $modal.find('.prev-button');
    var $nextButton = $modal.find('.next-button');

    var $main = $body.children('main');
    var $dotContainers = $main.find('#park-map-container .dot-container');
    var $dotLabelWrappers = $dotContainers.find('.dot-label-wrapper');

    var scrollPosition = undefined;
    var modalLoading = false;

    var pageCache = {
        /* [data-page-id] : data */
    };
    var currentPageID, previousPageID, nextPageID;

    var decadeClasses = ['10', '00', '90', '80', '70', '60'];
    var articleClasses = ['sculpture', 'story', 'milestones'];

    function init() {
        /* hide the modal */
        $body.addClass('article-modal-hidden');
        bind();
    }

    function bind() {
        /* dot clicks */
        if (!Modernizr.touchevents) {
            $dotContainers.on('click', onClickDot);
        } else {
            $dotLabelWrappers.on('click', onTouchDot);
        }

        $closeToggle.on('click', onCloseToggleClick);
        $aboutToggle.on('click', onAboutToggleClick);
        $prevButton.on('click', onNavigationClick);
        $nextButton.on('click', onNavigationClick);
    }

    function resetTouchDots($currentDot) {
        $dotContainers.not($currentDot).filter('.touch-active').trigger('click');
    }

    function getPage(page_id, navigation) {
        if (!page_id && page_id !== 0) {
            return false;
        }

        var token = $('[name="csrf_token"]').attr('content');

        if (typeof pageCache[page_id] === 'undefined') {
            $.post('/page', { page_id: page_id, _token: token }).done(function (data) {
                pageCache[page_id] = data;
                loadPage(page_id, data, navigation);
            }).fail(function (xhr, status, error) {
                loadPage(page_id, { error: '<p class="error-message">This content could not be loaded. Please try again.</p>' });
            });
        } else {
            loadPage(page_id, pageCache[page_id], navigation);
        }
    }

    function loadPage(page_id, data, navigation) {
        if (!page_id || !data) {
            return false;
        }

        if (data.article_about_modal == null) {
            $aboutToggle.hide();
        } else {
            $aboutToggle.show();
        }

        updatePageIDs(page_id);
        /* the response errored out */
        if (typeof data.error !== 'undefined') {
            var $content = $('<div class="content">' + data.error + '</div>');
            $modal.append($content);
            return false;
        }

        /* unhide the modal */
        $body.removeClass('article-modal-hidden');

        updateModalClasses(data, navigation);

        var $content = $modal.children('.content');
        if ($content.length > 0 && navigation) {
            var animateIn, animateOut;
            if (navigation == 'previous') {
                animateIn = 'animate-from-previous';
                animateOut = 'animate-to-next';
            } else {
                animateIn = 'animate-from-next';
                animateOut = 'animate-to-previous';
            }
            $content.addClass(animateOut);
            var $newContent = $('<div class="content ' + animateIn + '">' + data.content + '</div>');
            $modal.append($newContent);

            setTimeout(function () {
                $content.remove();
                $newContent.removeClass(animateIn);
                $modal.removeClass('is-animating');
            }, 1000);
        } else {
            var $content = $('<div class="content">' + data.content + '</div>');
            $modal.append($content);
        }

        /* run polyfill for object-fit */
        $(document).trigger('modal::objectFitImages');

        modalLoading = false;

        setTimeout(function () {
            $body.addClass('article-modal-open');
            $modal.removeClass('is-animating unfold-animation-in');
            $main.css('top', -1 * scrollPosition);
        }, 1500);
    }

    function updateModalClasses(data, navigation) {
        /* remove decade classes */
        for (var i = 0; i < decadeClasses.length; i++) {
            $modal.removeClass('decade-' + decadeClasses[i]);
            $modalBackground.removeClass('decade-' + decadeClasses[i]);
        }

        /* remove article classes */
        for (var i = 0; i < articleClasses.length; i++) {
            $modal.removeClass(articleClasses[i]);
            $modalBackground.removeClass(articleClasses[i]);
        }

        /* remove layout classes */
        $modal.removeClass('full-photo-background-layout-modal single-column-layout-modal two-column-layout-modal undefined-layout-modal');
        $modalBackground.removeClass('full-photo-background-layout-modal single-column-layout-modal two-column-layout-modal undefined-layout-modal');

        var decades = '';
        if (_typeof(data.decade) === 'object') {
            for (var i = 0; i < data.decade.length; i++) {
                decades += ' decade-' + data.decade[i];
            }
        } else {
            decades = 'decade-' + data.decade;
        }

        //$modal.attr('class', 'unfold-animation-in');
        //$modalBackground.attr('class', 'article-modal-background unfold-animation-in')

        var article = data.article_type;

        var content = $(data.content).attr('id') + '-layout-modal';

        var aboutModal = data.article_about_modal ? 'has-about-modal' : '';

        $modal.removeClass('has-about-modal');

        /* apply new classes */
        $modal.addClass('is-animating ' + decades + ' ' + article + ' ' + content + ' ' + aboutModal);
        $modalBackground.addClass(decades + ' ' + article + ' ' + content);

        /* if the modal is not already open */
        if (!navigation) {
            $modal.removeClass('unfold-animation-in unfold-animation-out');
            $modalBackground.removeClass('unfold-animation-in unfold-animation-out');

            $modal.addClass('unfold-animation-in');
            $modalBackground.addClass('unfold-animation-in');
        }
    }

    function updatePageIDs(page_id) {
        currentPageID = page_id;
        previousPageID = getNavigationID('prev', currentPageID);
        nextPageID = getNavigationID('next', currentPageID);

        if (!previousPageID) {
            $modal.addClass('no-prev');
        } else {
            $modal.removeClass('no-prev');
        }

        if (!nextPageID) {
            $modal.addClass('no-next');
        } else {
            $modal.removeClass('no-next');
        }
    }

    function getNavigationID(type, currentArticleID) {
        var currentIndex, targetIndex, targetPageID;
        var $activeDotContainers = $dotContainers.filter('.filter-active');

        for (var i = 0; i < $activeDotContainers.length; i++) {
            if ($activeDotContainers.eq(i).attr('data-page-id') === currentArticleID) {
                currentIndex = i;
                break;
            }
        }

        if (type === 'prev') {
            targetIndex = currentIndex - 1;
            return $activeDotContainers.eq(targetIndex).attr('data-page-id');
        } else if (type === 'next') {
            targetIndex = currentIndex + 1;
            return $activeDotContainers.eq(targetIndex).attr('data-page-id');
        } else {
            return false;
        }
    }

    function onClickDot(event) {
        if (!event) {
            return false;
        }
        event.preventDefault();

        if (modalLoading) {
            return false;
        }

        scrollPosition = $(document).scrollTop();
        modalLoading = true;
        getPage($(this).attr('data-page-id'));
    }

    function onTouchDot(event) {
        if (!event) {
            return false;
        }
        event.preventDefault();

        var $dotContainer = $(this).parent();

        if (modalLoading || !$dotContainer.hasClass('touch-active') || !$dotContainer.hasClass('filter-active')) {
            return false;
        }
        scrollPosition = $(document).scrollTop();
        modalLoading = true;
        getPage($dotContainer.attr('data-page-id'));
    }

    function onCloseToggleClick(event) {
        if (!event) {
            return false;
        }
        event.preventDefault();

        $body.removeClass('article-modal-open');
        $main.css('top', '');
        $(document).scrollTop(scrollPosition);

        $modal.addClass('unfold-animation-in unfold-animation-out');
        $modalBackground.addClass('unfold-animation-out');

        setTimeout(function () {
            $body.addClass('article-modal-hidden');
            $modal.attr('class', 'unfold-animation-in');
            $modalBackground.attr('class', 'article-modal-background unfold-animation-in');
        }, 1500);
    }

    function onNavigationClick(event) {
        if (!event || $modal.hasClass('is-animating')) {
            return false;
        }
        event.preventDefault();

        if ($(this).hasClass('prev-button')) {
            if ($modal.hasClass('no-prev')) {
                return false;
            }
            getPage(previousPageID, 'previous');
        } else if ($(this).hasClass('next-button')) {
            if ($modal.hasClass('no-next')) {
                return false;
            }
            getPage(nextPageID, 'next');
        }
        return false;
    }

    function onAboutToggleClick(event) {
        event.preventDefault();
        $modal.toggleClass('about-modal-open');
    }

    init();
})(jQuery);

},{}],8:[function(require,module,exports){
'use strict';

(function ($, bodymovin) {

    var $bodymovin = $('.bodymovin.bodymovin-button');

    if ($bodymovin.length == 0) {
        return false;
    }

    /* cached Strings of json data */
    var animationData = {
        horizontal: undefined,
        vertical: undefined
    };

    var defaultParams = {
        container: undefined, /* this gets defined during init */
        animationData: undefined, /* this gets defined during init */
        renderer: 'svg',
        loop: false,
        autoplay: false,
        rendererSettings: {
            preserveAspectRatio: 'none'
        }
    };

    var players = {};

    function init() {
        $.getJSON('../bodymovin/vertical-button.json', function (verticalJSON) {
            animationData.vertical = verticalJSON;
            $.getJSON('../bodymovin/horizontal-button.json', function (horizontalJSON) {
                animationData.horizontal = horizontalJSON;

                $bodymovin.each(function (i) {
                    loadAnimation($(this), i);
                });
                bind();
            });
        });
    }

    window.initBodymovinButton = function ($button) {
        if (!$button) {
            return false;
        }
        loadAnimation($button, players.length);
    };

    function bind() {}

    function bindPlayer(player) {
        if (!player) {
            return false;
        }

        /* cache JSON data if it was not successfully done during init */
        player.addEventListener('data_ready', function () {
            cacheJSON(player);
        });

        player.wrapper.addEventListener('mouseover', function () {
            onMouseOver(player);
        });
        player.wrapper.addEventListener('mouseout', function () {
            onMouseOut(player);
        });
    }

    function loadAnimation($button, i) {
        var params = defaultParams;
        params.container = $button.get(0);

        if ($button.hasClass('vertical-button') && animationData.vertical) {
            /* check if json cached */
            params.animationData = animationData.vertical;
        } else if ($button.hasClass('horizontal-button') && animationData.horizontal) {
            /* check if json cached */
            params.animationData = animationData.horizontal;
        } else if ($button.hasClass('vertical-button')) {
            /* if json not cached, try again */
            params.path = '../bodymovin/vertical-button.json';
        } else if ($button.hasClass('horizontal-button')) {
            /* if json not cached, try again */
            params.path = '../bodymovin/horizontal-button.json';
        }

        players[i] = bodymovin.loadAnimation(params);

        bindPlayer(players[i]);
    }

    function cacheJSON(player) {
        if (!player) {
            return false;
        }
        if ($(player.wrapper).hasClass('horizontal-button') && !animationData.horizontal) {
            animationData.horizontal = player.animationData;
        } else if ($(player.wrapper).hasClass('vertical-button') && !animationData.vertical) {
            animationData.vertical = player.animationData;
        }
    }

    function onMouseOver(player) {
        if (!player) {
            return false;
        }

        player.setDirection(1);
        player.playSegments([0, 30], true);
    }

    function onMouseOut(player) {
        if (!player) {
            return false;
        }

        if (Math.round(player.currentFrame) < 30) {
            player.setDirection(-1);
            player.play();
        } else {
            player.playSegments([60, 91], true);
        }
    }

    init();
})(jQuery, bodymovin);

},{}],9:[function(require,module,exports){
'use strict';

(function ($, bodymovin) {

    if (!bodymovin) {
        return false;
    }

    var sculpture = {
        $dots: undefined,
        $dotContainers: undefined,
        $labelWrappers: undefined,
        $labels: undefined
    };

    var map = {
        $dots: undefined,
        $dotContainers: undefined,
        $labelWrappers: undefined,
        $labels: undefined
    };

    /* cached String of json data */
    var animationData = undefined;

    var defaultParams = {
        container: undefined, /* this gets defined during init */
        animationData: undefined, /* this gets defined during init */
        renderer: 'svg',
        loop: false,
        autoplay: false,
        rendererSettings: {
            preserveAspectRatio: 'none'
        }
    };

    var players = {};

    /* prevent rapid click events if currently animating */
    var isAnimating = false;

    function init() {
        bind();
    }

    function initDots() {
        sculpture.$dots = $('#living-sculpture .bodymovin.bodymovin-dot');
        map.$dots = $('#park-map-container .bodymovin.bodymovin-dot');

        if (sculpture.$dots.length > 0) {
            sculpture.$dotContainers = sculpture.$dots.parents('.dot-container');
            sculpture.$labelWrappers = sculpture.$dotContainers.children('.dot-label-wrapper');
            sculpture.$labels = sculpture.$labelWrappers.children('.dot-label');
        }

        if (map.$dots.length > 0) {
            map.$dotContainers = map.$dots.parents('.dot-container');
            map.$labelWrappers = map.$dotContainers.children('.dot-label-wrapper');
            map.$labels = map.$labelWrappers.children('.dot-label');
        }

        $.getJSON('../bodymovin/dot.json', function (dotJSON) {
            animationData = dotJSON;
            loadAnimations();
        });

        resizeLabelWrappers();
    }

    function bind() {
        $(window).on('resize', resizeLabelWrappers);
        $(document).on('bodymovin::initDots', initDots);
    }

    function bindPlayer(player, dotType) {
        if (!player) {
            return false;
        }

        /* cache JSON data if it was not successfully done during init */
        player.addEventListener('data_ready', function () {
            cacheJSON(player);
        });

        player.addEventListener('enterFrame', function () {
            animateLabel(player);
        });

        if (!Modernizr.touchevents) {
            player.wrapper.addEventListener('mouseover', function (event) {
                event.preventDefault();

                if (dotType == 'map' && !$(this).parent().hasClass('filter-active')) {
                    return false;
                }
                resizeLabelWrapper($(this).siblings('.dot-label-wrapper'));
                onMouseOver(player);
            });
            player.wrapper.addEventListener('mouseout', function (event) {
                event.preventDefault();

                if (dotType == 'map' && !$(this).parent().hasClass('filter-active')) {
                    return false;
                }
                onMouseOut(player);
            });
        } else {
            player.wrapper.addEventListener('click', function (event) {
                event.preventDefault();

                if (dotType == 'map' && !$(this).parent().hasClass('filter-active')) {
                    return false;
                }

                resizeLabelWrapper($(this).siblings('.dot-label-wrapper'));
                onMobileClick(player);
            });

            $(player.wrapper).on('dot::close', function (event) {
                resizeLabelWrapper($(this).siblings('.dot-label-wrapper'));
                onMobileClick(player);
            });
        }
    }

    function loadAnimations() {
        if (sculpture.$dots.length > 0) {
            sculpture.$dots.each(function (i) {
                var params = defaultParams;
                params.container = this;

                if (animationData) {
                    /* check if json cached */
                    params.animationData = animationData;
                } else {
                    /* if json not cached, try again */
                    params.path = '../bodymovin/dot.json';
                }

                players[i] = bodymovin.loadAnimation(params);

                bindPlayer(players[i], 'sculpture');
            });
        }

        if (map.$dots.length > 0) {
            map.$dots.each(function (i) {
                var params = defaultParams;
                params.container = this;

                if (animationData) {
                    /* check if json cached */
                    params.animationData = animationData;
                } else {
                    /* if json not cached, try again */
                    params.path = '../bodymovin/dot.json';
                }

                players[i] = bodymovin.loadAnimation(params);

                bindPlayer(players[i], 'map');
            });
        }
    }

    function cacheJSON(player) {
        if (!player && !animationData) {
            return false;
        }
        animationData = player.animationData;
    }

    function animateLabel(player) {
        if (!player) {
            return false;
        }
        var $label = $(player.wrapper).siblings('.dot-label-wrapper').children('.dot-label');
        var width = $label.width();
        var amount = width * -1.75 + width * 1.75 * (player.currentFrame / player.totalFrames);
        amount = amount > width ? width : amount;

        $label.css('transform', 'translateX(' + amount + 'px)');
    }

    function resizeLabelWrappers(event) {
        if (sculpture.$labelWrappers.length > 0) {
            sculpture.$labelWrappers.each(function () {
                $(this).width($(this).children('.dot-label').outerWidth());
            });
        }

        if (map.$labelWrappers.length > 0) {
            map.$labelWrappers.each(function () {
                $(this).width($(this).children('.dot-label').outerWidth());
            });
        }
    }
    function resizeLabelWrapper($wrapper) {
        if (!$wrapper) {
            return false;
        }
        $wrapper.width($(this).children('.dot-label').outerWidth());
    }

    function onMouseOver(player) {
        if (!player) {
            return false;
        }
        isAnimating = true;
        player.setDirection(1);
        player.setSpeed(2);
        player.play();
        //player.goToAndStop(player.totalFrames, true);

        setTimeout(function () {
            $(player.wrapper).parent().addClass('touch-active');
            isAnimating = false;
        }, player.totalFrames * 60 / player.playSpeed);
    }

    function onMouseOut(player) {
        if (!player) {
            return false;
        }

        isAnimating = true;
        player.setDirection(-1);
        player.play();

        setTimeout(function () {
            $(player.wrapper).parent().removeClass('touch-active');
            isAnimating = false;
        }, player.totalFrames * 60 / player.playSpeed);
    }

    function onMobileClick(player) {
        if (!player) {
            return false;
        }

        if (player.currentFrame == 0 && !isAnimating) {
            onMouseOver(player);
        } else if (Math.round(player.currentFrame) == player.totalFrames) {
            onMouseOut(player);
        }
    }

    init();
})(jQuery, bodymovin);

},{}],10:[function(require,module,exports){
'use strict';

(function () {
    var browserDetect = require('browser-detect');

    if (!browserDetect) {
        return false;
    }

    var html = document.querySelector('html');
    var browser = browserDetect();

    /* add browser class */
    html.classList.add('is-' + browser.name.toLowerCase());

    if (browser.mobile) {
        html.classList.add('is-mobile');
    } else {
        html.classList.add('not-mobile');
    }

    /* add OS class */
    if (browser.os.indexOf('OS X') !== -1) {
        html.classList.add('is-osx');
    } else if (browser.os.indexOf('Android') !== -1 || browser.os.indexOf('android') !== -1) {
        html.classList.add('is-android');
    }
})();

},{"browser-detect":1}],11:[function(require,module,exports){
'use strict';

(function ($) {
    var $window = $(window);
    var $document = $(document);
    var $section = $('#park-map-container');

    if ($section.length === 0) {
        return false;
    }

    var $background = $section.find('.background-image');
    var $clouds01 = $section.find('.clouds01');
    var $clouds02 = $section.find('.clouds02');

    var filters = {};
    filters.$container = $section.find('#map-filters');
    filters.options = {};
    filters.options.$decades = filters.$container.find('#decade-filter li');
    filters.options.$articles = filters.$container.find('#article-filter li');

    var map = {};
    map.$container = $section.find('#park-map');
    map.$mapLines = map.$container.find('svg#roads-paths');
    map.$buildings = map.$container.find('#buildings');
    map.$buildingShadows = map.$container.find('#shadows');
    map.$dotsContainer = $section.find('#map-dots-container');
    map.$dots = map.$dotsContainer.find('.dot');
    map.$drag = $section.find('.map-drag');

    var modal = {};
    modal.$container = $section.find('#map-intro-text');
    modal.$close = modal.$container.find('.close');

    var $socialLinks = map.$container.find('.social-links');

    /* touch-related data */
    var touchConfig = {
        scale: {
            min: 0.5,
            max: 2
        }
    };
    var touch = {
        config: touchConfig,
        count: 0, // current number of pointers
        origin: undefined, // origin touch events
        previous: undefined, // previous touch events
        current: undefined, // current touch events
        direction: undefined, // detected directions of each touch event
        inertia: 0, // the calculated inertia of the movement
        styles: {
            translateX: {
                previous: 0,
                current: 0
            },
            scale: {
                previous: 1,
                current: 1
            },
            transform: {
                translate3d: '', /* prepared string */
                scale: '' /* prepared string */
            }
        }
    };

    // Closes the map description box
    $('#map-intro-text .close').click(function (e) {
        e.preventDefault();

        $(this).parent().fadeOut(400, function () {
            $(this).remove();
        });
    });

    function init() {
        centerMap();
        bind();
    }

    function bind() {
        $window.on('resize', onResize);
        $document.on('mousemove', onMouseMove);

        /* only make map draggable if touch events are detected and the window is smaller than the map container */
        if (Modernizr.touchevents && ($window.width() < map.$container.width() || $window.height() < map.$container.height())) {
            var drag = map.$drag.get(0);
            drag.addEventListener('touchstart', onTouchStart, false);
            drag.addEventListener('touchend', onTouchEnd, false);
            drag.addEventListener('touchcancel', onTouchCancel, false);
            drag.addEventListener('touchmove', onTouchMove, false);
        } else {
            // drag.addEventListener('click', function(event) { console.log('click', event);}, false);
            // drag.addEventListener('mousedown', function(event) { console.log('mousedown', event);}, false);
            // drag.addEventListener('mouseup', function(event) { console.log('mouseup', event);}, false);
            // drag.addEventListener('mousemove', function(event) { console.log('mousemove', event);}, false);
        }
    }

    function parallax(element, resistance, event) {
        TweenLite.to(element, 0.2, {
            x: -((event.clientX - window.innerWidth / 2) / resistance),
            y: -((event.clientY - window.innerHeight / 2) / resistance)
        });
    }

    function centerMap() {
        var left = (map.$container.outerWidth() - $(window).outerWidth()) / -2;
        map.$drag.css('left', left + 'px');
        map.$container.css('left', left + 'px');
        map.$dotsContainer.css('left', left + 'px');
    }

    function resetMap() {
        centerMap();

        /* set the map back to original position */
        map.$drag.css('transform', '');
        map.$container.css('transform', '');
        map.$dotsContainer.css('transform', '');

        touch = {
            config: touchConfig,
            count: 0, // current number of pointers
            origin: undefined, // origin touch events
            previous: undefined, // previous touch events
            current: undefined, // current touch events
            direction: undefined, // detected directions of each touch event
            inertia: 0, // the calculated inertia of the movement
            styles: {
                translateX: {
                    previous: 0,
                    current: 0
                },
                scale: {
                    previous: 1,
                    current: 1
                },
                transform: {
                    translate3d: '', /* prepared string */
                    scale: '' /* prepared string */
                }
            }
        };
    }

    function onResize(event) {
        resetMap();
    }

    function onMouseMove(event) {
        if (!event) {
            return false;
        }
        // parallax($background.get(0), -30, event);
        parallax($clouds01.get(0), 30, event);
        parallax($clouds02.get(0), 10, event);
    }

    function updateTouch(event) {
        if (!event) {
            return false;
        }

        touch.count = event.touches.length;
        touch.origin = event.touches;
        touch.previous = touch.origin;
    }

    function touchAnimate() {
        var transform = touch.styles.transform.translate3d + ' ' + touch.styles.transform.scale;
        map.$drag.css('transform', transform);
        map.$container.css('transform', transform);
        map.$dotsContainer.css('transform', transform);
    }

    function touchDrag(event) {
        if (!event) {
            return false;
        }
        touch.inertia = touch.current[0].clientX - touch.previous[0].clientX;
        touch.styles.translateX.current = touch.styles.translateX.previous + touch.inertia;
        touch.styles.transform.translate3d = 'translate3d(' + touch.styles.translateX.current + 'px,0,0)';

        touch.previous = touch.current;
        touch.styles.translateX.previous = touch.styles.translateX.current;

        if (touch.inertia !== 0) {
            window.requestAnimationFrame(touchAnimate);
        }
    }

    function touchPinchZoom(event) {
        if (!event || touch.count < 2) {
            return false;
        }

        var zoom;

        /* exit if the expected events do not exist */
        if (typeof touch.current[0] === 'undefined' || typeof touch.current[1] === 'undefined' || typeof touch.previous[0] === 'undefined' || typeof touch.previous[1] === 'undefined') {
            return false;
        }
        touch.inertia = (touch.current[0].clientX - touch.previous[0].clientX + (touch.current[1].clientX - touch.previous[1].clientX)) / 2;

        /* exit if pointers were idle */
        if (touch.inertia === 0) {
            return false;
        }

        touch.direction = touch.direction ? touch.direction : {};

        for (var i = 0; i < 2; i++) {
            if (touch.current[i] && touch.previous[i]) {
                if (touch.current[i].clientX < touch.previous[i].clientX) {
                    touch.direction[i] = 'left';
                } else if (touch.current[i].clientX > touch.previous[i].clientX) {
                    touch.direction[i] = 'right';
                } else {
                    touch.direction[i] = 'none';
                }
            }
        }

        if (touch.direction[0] === touch.direction[1]) {
            /* both pointers moving in the same direction or no direction */
            return false;
        } else if (touch.direction[0] === 'none') {
            /* if first pointer did not change */
            if (touch.direction[1] === 'left') {
                zoom = -1;
            } else if (touch.direction[1] === 'right') {
                zoom = 1;
            }
        } else if (touch.direction[1] === 'none') {
            /* if second pointer did not change */
            if (touch.direction[0] === 'left') {
                zoom = 1;
            } else if (touch.direction[0] === 'right') {
                zoom = -1;
            }
        } else if (touch.direction[0] === 'left' && touch.direction[1] === 'right') {
            /* if pointers are moving wider */
            zoom = -1;
        } else if (touch.direction[0] === 'right' && touch.direction[1] === 'left') {
            /* if pointers are moving closer */
            zoom = -1;
        } else {
            return false;
        }

        var scaleInertia = touch.inertia / 100 * zoom;
        touch.styles.scale.current = touch.styles.scale.previous + scaleInertia;
        touch.styles.scale.current = touch.styles.scale.current < touch.config.scale.min ? touch.config.scale.min : touch.styles.scale.current;
        touch.styles.scale.current = touch.styles.scale.current > touch.config.scale.max ? touch.config.scale.max : touch.styles.scale.current;

        touch.styles.scale.previous = touch.styles.scale.current;
        touch.styles.transform.scale = 'scale(' + touch.styles.scale.current + ')';

        window.requestAnimationFrame(touchAnimate);
    }

    function onTouchStart(event) {
        if (!event) {
            return false;
        }
        updateTouch(event);
    }

    function onTouchMove(event) {
        if (!event) {
            return false;
        }

        touch.current = event.touches;

        /* route the behavior based on number of pointers touching the screen */
        if (touch.count === 1) {
            touchDrag(event); /* if only one pointer, do a drag */
        } else if (typeof event.scale === 'undefined') {
            /* if event.scale exists (ios) then the device handles the scaling natively */
            touchPinchZoom(event); /* if two pointers, do a pinch-zoom */
        }
    }

    function onTouchEnd(event) {
        if (!event) {
            return false;
        }
        updateTouch(event);
    }

    function onTouchCancel(event) {
        if (!event) {
            return false;
        }
        updateTouch(event);
    }

    init();
})(jQuery);

},{}],12:[function(require,module,exports){
'use strict';

(function ($) {
    var $body = $('body');
    var $section = $body.find('#park-map-container');

    var $filtersContainer = $section.find('#map-filters');
    var $filtersMenu = $filtersContainer.find('.filters');
    var $filtersMenuOpenToggle = $filtersContainer.find('h3');
    var $filtersMenuHideToggle = $filtersMenu.find('.hide');
    var $decadeFilter = $filtersMenu.find('#decade-filter');
    var $decadeFilterOptions = $decadeFilter.find('li');
    var $articleFilter = $filtersMenu.find('#article-filter');
    var $articleFilterOptions = $articleFilter.find('li');

    var $dotContainers = $section.find('.dot-container');

    /* responsively showing the filter menu open by default, while also not opening a closed menu on resize */
    var hasShownFilterMenu = false;

    function init() {
        bind();

        /* set mobile menu to be open by default */
        hasShownFilterMenu = true;
        showFilterMenu();

        /* set the first decade filter to be selected by default */
        $decadeFilterOptions.eq(0).trigger('click');
    }

    function bind() {
        $decadeFilterOptions.on('click', onFilterClick);
        $articleFilterOptions.on('click', onFilterClick);

        // Animate mobile filter menu
        $filtersMenuOpenToggle.on('click', showFilterMenu);
        // Animate mobile filter menu
        $filtersMenuHideToggle.on('click', hideFilterMenu);

        $(window).on('resize', onResize);
    }

    function onFilterClick(event) {

        if (!event) {
            return false;
        }
        event.preventDefault();

        var $thisFilterOption = $(this);

        var filters = {
            decades: [],
            articles: []
        };

        /* Allow for multiple decades filters at a time. */
        if ($thisFilterOption.parent().is($decadeFilter)) {
            if ($thisFilterOption.hasClass('active')) {
                $thisFilterOption.removeClass('active');

                /* if no other decade filter is set, default to the first option (10s) */
                if ($decadeFilterOptions.filter('.active').length === 0) {
                    $decadeFilterOptions.eq(0).addClass('active');
                }
            } else {
                //$decadeFilterOptions.removeClass('active');
                $thisFilterOption.addClass('active');
            }
        }

        /* Allow for multiple article filters at a time. */
        if ($thisFilterOption.parent().is($articleFilter)) {
            $thisFilterOption.toggleClass('active');
        }

        /* reset dots */
        $dotContainers.removeClass('filter-active');

        /* discover active decade filters */
        $decadeFilterOptions.each(function (index, filter) {
            if ($(this).hasClass('active')) {
                filters.decades.push('.' + $(filter).data('filter'));
            }
        });

        /* discover active article filters */
        $articleFilterOptions.each(function (index, filter) {
            if ($(this).hasClass('active')) {
                filters.articles.push('.' + $(filter).data('filter'));
            }
        });

        if (filters.decades.length == 0 && filters.articles.length == 0) {
            $dotContainers.addClass('filter-active');
        } else if (filters.decades.length == 0) {
            for (var i = 0; i < filters.articles.length; i++) {
                $dotContainers.each(function () {
                    if ($(this).is(filters.articles[i])) {
                        $(this).addClass('filter-active');
                    }
                });
            }
        }if (filters.articles.length == 0) {
            for (var i = 0; i < filters.decades.length; i++) {
                $dotContainers.each(function () {
                    if ($(this).is(filters.decades[i])) {
                        $(this).addClass('filter-active');
                    }
                });
            }
        } else {
            for (var i = 0; i < filters.decades.length; i++) {
                for (var n = 0; n < filters.articles.length; n++) {
                    $dotContainers.each(function () {
                        if ($(this).is(filters.decades[i] + filters.articles[n])) {
                            $(this).addClass('filter-active');
                        }
                    });
                }
            }
        }
        /* if touch ui, close all active dots that do not match new filter criteria */
        if (Modernizr.touchevents) {
            $dotContainers.filter('.touch-active').not('.filter-active').each(function () {
                $(this).children('a.dot').trigger('dot::close');
            });
        }
    }

    function onResize(event) {
        /* Always show filter menu open by default */

        if (window.isDesktop()) {
            hasShownFilterMenu = false;
        } else if (!hasShownFilterMenu) {
            hasShownFilterMenu = true;
            showFilterMenu();
        }
    }

    function showFilterMenu(event) {
        if (event && typeof event.preventDefault !== 'undefined') {
            event.preventDefault();
        }

        $body.addClass('map-filters-menu-open');
    }

    function hideFilterMenu(event) {
        if (event && typeof event.preventDefault !== 'undefined') {
            event.preventDefault();
        }

        $body.removeClass('map-filters-menu-open');
    }

    init();
})(jQuery);

},{}],13:[function(require,module,exports){
'use strict';

$(function () {

    var drawSculpture = function drawSculpture() {

        var containerSize = window.innerWidth > 1024 ? .6 : .8;
        var sculptureWidth = window.innerWidth * .8;
        var sculptureHeight = window.innerHeight * containerSize;

        $('#living-sculpture #sculpture').attr('viewBox', '0 0 ' + sculptureWidth + ' ' + sculptureHeight);

        $.get('/sculpture', function (response) {

            if (window.innerWidth < 768) {
                // Hashtags to only show on mobile
                var hashtags = ['#LaumeierSculpturePark', '#LSP', '#Laumeier', '#stlouis', '#stl', '#laumeier40', '#LaumeierSTL', '#art', '#sculpturepark', '#sculpture', '#photography', '#family', '#nofilter', '#park', '#weekend'];

                var filteredDots = response.dots.filter(function (element) {
                    return hashtags.indexOf(element.hashtag) > 0;
                });

                response.dots = filteredDots;
            }

            var dotX = (sculptureWidth - 30) / parseInt(response.dots.length);
            var nextDotX = 22;

            var sculpture = '<svg id="sculpture" viewBox="0 0 ' + sculptureWidth + ' ' + sculptureHeight + '" xmlns="http://www.w3.org/2000/svg">';
            var sculptureDots = '';
            var sculptureLines = '';
            var dots = [];

            response.dots.forEach(function (dot) {
                var dotY = sculptureHeight - sculptureHeight / parseInt(response.max_posts_count) * parseInt(dot.post_count) - 15;

                dotY = dotY < 22 ? 22 : dotY;

                dots.push({
                    x: nextDotX,
                    y: dotY
                });

                // Set dot size based on hour.
                var dotRadius = dot.hour < 8 ? 3 : dot.hour > 20 ? 12 : Math.abs((dot.hour - 8) * .75 + 3);

                sculptureDots += '<g transform="translate(' + nextDotX + ',' + dotY + ')" data-x="' + nextDotX + '" data-y="' + dotY + '">' +
                //  '<rect class="flag-background"/>'+
                //  '<path class="flag-connection" d="M0,0V.5H0V1A10.17,10.17,0,0,1,10.16,11.16,10.17,10.17,0,0,1,0,21.33v.5H0v.5H13.58V0Z"/>'+
                '<circle cx="0" cy="0" r="' + dotRadius + '" class="svg-dot" />' +
                //  '<circle cx="0" cy="0" r="17" class="circle" data-hashtag="'+dot.hashtag+'" data-time="'+dot.average_time+'" data-posts-count="'+dot.post_count+'" />'+
                //  '<text class="flag-text">'+dot.hashtag+'</text>'+
                //  '<polygon class="arrow" points="112.814,0 91.566,21.178 273.512,203.718 91.566,386.258 112.814,407.436 315.869,203.718 "></polygon>'+
                '</g>';

                if (sculptureWidth - nextDotX <= 150) {
                    var dotContainerClass = 'dot-container flag-left';
                    var dotArrowClass = 'dot-arrow left';
                } else {
                    var dotContainerClass = 'dot-container';
                    var dotArrowClass = 'dot-arrow';
                }

                $('#living-sculpture').prepend('<div class="' + dotContainerClass + '" style="left: ' + Math.abs(nextDotX - 17) + 'px; top: ' + Math.abs(dotY - 17) + 'px">' + '<a href="#" class="dot bodymovin bodymovin-dot" data-x="' + nextDotX + '" data-y="' + dotY + '" data-hashtag="' + dot.hashtag + '" data-time="' + dot.average_time + '" data-posts-count="' + dot.post_count + '"></a>' + '<span class="dot-label-wrapper">' + '<span class="dot-label">' + '<span class="hashtag-label">' + dot.hashtag + '</span>' + '<svg class="' + dotArrowClass + '" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 407.436 407.436">' + '<polygon points="112.814,0 91.566,21.178 273.512,203.718 91.566,386.258 112.814,407.436 315.869,203.718 "/>' + '</svg>' + '</span>' + '</span>' + '</div>');
                nextDotX = Math.abs(nextDotX + dotX);
            });

            dots.forEach(function (dot) {

                var c = [];
                var distances = [];

                dots.forEach(function (connectedDot, dotIndex) {
                    var a = Math.abs(dot.x - connectedDot.x);
                    var b = Math.abs(dot.y - connectedDot.y);
                    var distance = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));

                    c.push({
                        dotIndex: dotIndex,
                        distance: distance
                    });

                    distances.push(distance);
                });

                var sum = distances.reduce(function (accumulator, currentValue) {
                    return accumulator + currentValue;
                });

                var avg = Math.abs(sum / c.length);

                c.sort(function (a, b) {
                    return a.distance - b.distance;
                });

                var connections = c.filter(function (object) {
                    return object.distance <= avg && object.distance != 0;
                });

                var dotCount = connections.length > 5 ? 5 : connections.length;

                for (var i = 0; i < dotCount; i++) {
                    sculptureLines += '<line x1="' + dot.x + '" y1="' + dot.y + '" x2="' + dots[connections[i].dotIndex].x + '" y2="' + dots[connections[i].dotIndex].y + '" class="line" />';
                }
            });

            sculpture += sculptureLines;
            sculpture += sculptureDots;

            sculpture += '</svg>';

            $('#living-sculpture').append(sculpture);

            $(document).trigger('bodymovin::initDots');

            // Set flag size
            $('#living-sculpture .circle').each(function (index, circle) {
                var circle = $('#living-sculpture .circle')[index].getBBox();
                var text = $('#living-sculpture .flag-text')[index].getBBox();
                var flagBackground = $($('#living-sculpture .flag-background')[index]);
                var flagConnection = $($('#living-sculpture .flag-connection')[index]);
                var flagText = $($('#living-sculpture .flag-text')[index]);

                flagBackground.css('height', circle.height + 3);
                flagBackground.css('width', '3px');
                flagConnection.css('height', circle.height);

                var x = circle.x + circle.width + 3;
                var y = circle.y;
                var textX = circle.x + circle.width + 20;
                var textY = circle.y + circle.height / 2 + text.height / 4 + 7;

                flagBackground.attr('x', x);
                flagBackground.attr('y', y - 1.4);

                flagText.attr('x', textX);
                flagText.attr('y', textY);
            });

            var openModal = function openModal($this) {
                $('body').css('overflow', 'hidden');
                $('body').css('position', 'fixed');

                $('body').prepend('<section id="instagram-modal">' + '<button type="button" class="close-modal">&times;</button>' + '</section>' + '<div class="instagram-modal-background unfold-animation-in">' + '<img src="/img/icon_loader.gif">' + '</div>');

                $('body').addClass('instagram-modal-open');

                var data = {
                    hashtag: $this.data('hashtag'),
                    time: $this.data('time'),
                    postsCount: $this.data('posts-count')
                };

                $.get('/sculpture/modal', data).done(function (response) {

                    $('#instagram-modal').append(response);
                    $('#instagram-modal').css('opacity', 1);

                    $('.instagram-modal-background img').remove();

                    /* run polyfill for object-fit */
                    $(document).trigger('modal::objectFitImages');

                    $('#instagram-modal .close-modal').click(function (e) {
                        e.preventDefault();
                        $('#instagram-modal').addClass('unfold-animation-in unfold-animation-out');
                        $('.instagram-modal-background').addClass('unfold-animation-out');

                        $('.instagram-modal-background').one('webkitAnimationEnd oanimationend msAnimationEnd animationend', function (e) {
                            $('#instagram-modal').remove();
                            $('.instagram-modal-background').remove();
                            $('body').removeClass('instagram-modal-open').css('overflow', 'inherit').css('position', 'inherit');
                        });
                    });

                    $('#instagram-modal .load-more').click(function (e) {
                        e.preventDefault();

                        var $this = $(this);
                        var textHTML = $this.html();
                        var scrollOffset = $('#instagram-modal .load-more')[0].offsetTop;

                        $this.html('<img src="/img/icon_loader.gif">');
                        $this.css('background', '#095e5c');

                        var data = {
                            hashtag: $(this).data('hashtag'),
                            offset: $(this).data('offset')
                        };

                        $.get('/sculpture/modal/paginate', data).done(function (response) {
                            $('#instagram-modal .load-more').before(response);

                            $this.css('background', '#e7fffe');
                            $this.html(textHTML);

                            $('#instagram-modal').animate({
                                scrollTop: scrollOffset
                            }, 1000);

                            $('#instagram-modal .load-more').data('offset', Math.abs($('#instagram-modal .load-more').data('offset') + 12));

                            if ($('#instagram-modal .load-more').data('offset') >= $('#instagram-modal .load-more').data('total')) {
                                $('#instagram-modal .load-more').remove();
                            }
                        });
                    });
                });
            };

            if (Modernizr.touchevents) {
                $('#living-sculpture .dot-label-wrapper').on('click', function (e) {
                    e.preventDefault();
                    openModal($(this).parent().find('.dot'));
                });
            } else {
                $('#living-sculpture .dot').on('click', function (e) {
                    e.preventDefault();
                    openModal($(this));
                });
            }
        });
    };

    drawSculpture();

    var resizeTimer;
    var cachedWidth = $(window).width();

    $(window).on('resize', function (e) {
        var newWidth = $(window).width();

        if (newWidth !== cachedWidth) {

            clearTimeout(resizeTimer);

            resizeTimer = setTimeout(function () {
                $('#living-sculpture').html('');
                drawSculpture();
            }, 250);

            cachedWidth = newWidth;
        }
    });
});

},{}],14:[function(require,module,exports){
'use strict';

(function ($) {

    /* some browsers scroll on document.documentElement (<html>) others scroll on document.body (<body>) */
    var $scrollingElements = $('html, body');

    var $links = $('a[href*="#"]').not('[href="#"]');

    function init() {
        bind();
    }

    function bind() {
        $links.on('click', onLinkClick);
    }

    function onLinkClick(event) {
        /* make sure event is defined, and the href is the same page */
        if (!event || location.pathname.replace(/^\//, '') !== this.pathname.replace(/^\//, '') || location.hostname !== this.hostname) {
            return false;
        }

        var $target = $(this.hash);

        if ($target.length == 0) {
            return false;
        }

        event.preventDefault();

        var options = {
            scrollTop: $target.offset().top
        };

        /* Calculate scroll duration based on distance to target */
        var currentOffset = $(window).scrollTop();
        var targetOffset = $target.offset().top;
        var duration = currentOffset >= targetOffset ? currentOffset - targetOffset : targetOffset - currentOffset;

        $scrollingElements.animate(options, duration, function () {
            $target.focus();
            if ($target.is(':focus')) {
                // Checking if the target was focused
                return false;
            } else {
                $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                $target.focus(); // Set focus again
            }
        });
    }

    init();
})(jQuery);

},{}],15:[function(require,module,exports){
'use strict';

(function ($) {
    var $window = $(window);
    var $html = $('html');
    var $container = $('#map-intro-text .info-year');

    if ($container.length == 0) {
        return false;
    }

    var hasAnimated = false;
    var firstYear = 1977;
    var currentYear = new Date().getFullYear();
    var yearCount = currentYear - firstYear;

    var thisInterval = setInterval(function () {
        if ($html.hasClass('wf-active')) {
            clearInterval(thisInterval);
            init();
        }
    }, 50);

    function init() {
        $container.html(firstYear.toString().slice(-2));
        if (!isVisible()) {
            bind();
        } else {
            animate();
        }
    }

    function bind() {
        $(window).on('scroll', onScroll);
    }

    function isVisible() {
        var windowTop = $window.scrollTop();
        var windowHeight = $window.height();
        var containerTop = $container.offset().top;

        if (windowTop + windowHeight > containerTop && windowTop < containerTop + windowHeight) {
            return true;
        }
        return false;
    }

    function animate(year) {
        if (hasAnimated) {
            return false;
        }
        hasAnimated = true;
        loop(firstYear + 1);
    }

    function loop(year) {
        setTimeout(function () {
            if (year > currentYear) {
                return false;
            }
            var nextYear = year + 1;
            $container.html(year.toString().slice(-2));
            loop(nextYear);
        }, 75);
    }

    function onScroll(event) {
        if (!event) {
            return false;
        }
        if (isVisible()) {
            animate();
        }
    }
})(jQuery);

},{}],16:[function(require,module,exports){
"use strict";

(function ($) {
    window.isMobile = function () {
        if (window.outerWidth <= 767) {
            return true;
        }
        return false;
    };

    window.isTablet = function () {
        if (window.outerWidth >= 768 && window.outerWidth <= 1023) {
            return true;
        }
        return false;
    };

    window.isDesktop = function () {
        if (window.outerWidth >= 1024) {
            return true;
        }
        return false;
    };
})(jQuery);

},{}],17:[function(require,module,exports){
'use strict';

(function ($) {
    var objectFitImages = require('object-fit-images');

    function init() {
        if (Modernizr.objectfit) {
            return false;
        }

        polyfillImages();
        bind();
    }

    function bind() {
        $(document).on('modal::objectFitImages', handleModalImages);
    }

    function polyfillImages($container) {
        var $container = typeof $container !== 'undefined' ? $container : $('body');

        var $images = $container.find('img').filter(function () {
            return $(this).css('font-family').indexOf('object-fit') !== -1;
        });

        objectFitImages($images, {
            watchMQ: true
        });
    }

    function handleModalImages(event) {
        if (!event) {
            return false;
        }
        polyfillImages($('#modal'));
    }

    init();
})(jQuery);

},{"object-fit-images":3}],18:[function(require,module,exports){
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*! modernizr 3.5.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-classlist-cssfilters-csspointerevents-cssvhunit-cssvmaxunit-cssvminunit-cssvwunit-flexbox-flexboxlegacy-flexboxtweener-forcetouch-inlinesvg-objectfit-picture-sizes-smil-srcset-svg-svgasimg-svgclippaths-svgfilters-svgforeignobject-touchevents-willchange-setclasses-testprop !*/
!function (e, t, n) {
  function r(e, t) {
    return (typeof e === "undefined" ? "undefined" : _typeof(e)) === t;
  }function i() {
    var e, t, n, i, o, s, a;for (var l in S) {
      if (S.hasOwnProperty(l)) {
        if (e = [], t = S[l], t.name && (e.push(t.name.toLowerCase()), t.options && t.options.aliases && t.options.aliases.length)) for (n = 0; n < t.options.aliases.length; n++) {
          e.push(t.options.aliases[n].toLowerCase());
        }for (i = r(t.fn, "function") ? t.fn() : t.fn, o = 0; o < e.length; o++) {
          s = e[o], a = s.split("."), 1 === a.length ? Modernizr[a[0]] = i : (!Modernizr[a[0]] || Modernizr[a[0]] instanceof Boolean || (Modernizr[a[0]] = new Boolean(Modernizr[a[0]])), Modernizr[a[0]][a[1]] = i), T.push((i ? "" : "no-") + a.join("-"));
        }
      }
    }
  }function o(e) {
    var t = x.className,
        n = Modernizr._config.classPrefix || "";if (_ && (t = t.baseVal), Modernizr._config.enableJSClass) {
      var r = new RegExp("(^|\\s)" + n + "no-js(\\s|$)");t = t.replace(r, "$1" + n + "js$2");
    }Modernizr._config.enableClasses && (t += " " + n + e.join(" " + n), _ ? x.className.baseVal = t : x.className = t);
  }function s() {
    return "function" != typeof t.createElement ? t.createElement(arguments[0]) : _ ? t.createElementNS.call(t, "http://www.w3.org/2000/svg", arguments[0]) : t.createElement.apply(t, arguments);
  }function a(t, n, r) {
    var i;if ("getComputedStyle" in e) {
      i = getComputedStyle.call(e, t, n);var o = e.console;if (null !== i) r && (i = i.getPropertyValue(r));else if (o) {
        var s = o.error ? "error" : "log";o[s].call(o, "getComputedStyle returning null, its possible modernizr test results are inaccurate");
      }
    } else i = !n && t.currentStyle && t.currentStyle[r];return i;
  }function l(e, t) {
    return e - 1 === t || e === t || e + 1 === t;
  }function u(e, t) {
    return !!~("" + e).indexOf(t);
  }function f(e) {
    return e.replace(/([a-z])-([a-z])/g, function (e, t, n) {
      return t + n.toUpperCase();
    }).replace(/^-/, "");
  }function d(e, t) {
    if ("object" == (typeof e === "undefined" ? "undefined" : _typeof(e))) for (var n in e) {
      P(e, n) && d(n, e[n]);
    } else {
      e = e.toLowerCase();var r = e.split("."),
          i = Modernizr[r[0]];if (2 == r.length && (i = i[r[1]]), "undefined" != typeof i) return Modernizr;t = "function" == typeof t ? t() : t, 1 == r.length ? Modernizr[r[0]] = t : (!Modernizr[r[0]] || Modernizr[r[0]] instanceof Boolean || (Modernizr[r[0]] = new Boolean(Modernizr[r[0]])), Modernizr[r[0]][r[1]] = t), o([(t && 0 != t ? "" : "no-") + r.join("-")]), Modernizr._trigger(e, t);
    }return Modernizr;
  }function c(e) {
    return e.replace(/([A-Z])/g, function (e, t) {
      return "-" + t.toLowerCase();
    }).replace(/^ms-/, "-ms-");
  }function p() {
    var e = t.body;return e || (e = s(_ ? "svg" : "body"), e.fake = !0), e;
  }function h(e, n, r, i) {
    var o,
        a,
        l,
        u,
        f = "modernizr",
        d = s("div"),
        c = p();if (parseInt(r, 10)) for (; r--;) {
      l = s("div"), l.id = i ? i[r] : f + (r + 1), d.appendChild(l);
    }return o = s("style"), o.type = "text/css", o.id = "s" + f, (c.fake ? c : d).appendChild(o), c.appendChild(d), o.styleSheet ? o.styleSheet.cssText = e : o.appendChild(t.createTextNode(e)), d.id = f, c.fake && (c.style.background = "", c.style.overflow = "hidden", u = x.style.overflow, x.style.overflow = "hidden", x.appendChild(c)), a = n(d, e), c.fake ? (c.parentNode.removeChild(c), x.style.overflow = u, x.offsetHeight) : d.parentNode.removeChild(d), !!a;
  }function v(t, r) {
    var i = t.length;if ("CSS" in e && "supports" in e.CSS) {
      for (; i--;) {
        if (e.CSS.supports(c(t[i]), r)) return !0;
      }return !1;
    }if ("CSSSupportsRule" in e) {
      for (var o = []; i--;) {
        o.push("(" + c(t[i]) + ":" + r + ")");
      }return o = o.join(" or "), h("@supports (" + o + ") { #modernizr { position: absolute; } }", function (e) {
        return "absolute" == a(e, null, "position");
      });
    }return n;
  }function m(e, t, i, o) {
    function a() {
      d && (delete j.style, delete j.modElem);
    }if (o = r(o, "undefined") ? !1 : o, !r(i, "undefined")) {
      var l = v(e, i);if (!r(l, "undefined")) return l;
    }for (var d, c, p, h, m, g = ["modernizr", "tspan", "samp"]; !j.style && g.length;) {
      d = !0, j.modElem = s(g.shift()), j.style = j.modElem.style;
    }for (p = e.length, c = 0; p > c; c++) {
      if (h = e[c], m = j.style[h], u(h, "-") && (h = f(h)), j.style[h] !== n) {
        if (o || r(i, "undefined")) return a(), "pfx" == t ? h : !0;try {
          j.style[h] = i;
        } catch (w) {}if (j.style[h] != m) return a(), "pfx" == t ? h : !0;
      }
    }return a(), !1;
  }function g(e, t) {
    return function () {
      return e.apply(t, arguments);
    };
  }function w(e, t, n) {
    var i;for (var o in e) {
      if (e[o] in t) return n === !1 ? e[o] : (i = t[e[o]], r(i, "function") ? g(i, n || t) : i);
    }return !1;
  }function A(e, t, n, i, o) {
    var s = e.charAt(0).toUpperCase() + e.slice(1),
        a = (e + " " + L.join(s + " ") + s).split(" ");return r(t, "string") || r(t, "undefined") ? m(a, t, i, o) : (a = (e + " " + V.join(s + " ") + s).split(" "), w(a, t, n));
  }function y(e, t, r) {
    return A(e, n, n, t, r);
  }var T = [],
      S = [],
      C = { _version: "3.5.0", _config: { classPrefix: "", enableClasses: !0, enableJSClass: !0, usePrefixes: !0 }, _q: [], on: function on(e, t) {
      var n = this;setTimeout(function () {
        t(n[e]);
      }, 0);
    }, addTest: function addTest(e, t, n) {
      S.push({ name: e, fn: t, options: n });
    }, addAsyncTest: function addAsyncTest(e) {
      S.push({ name: null, fn: e });
    } },
      Modernizr = function Modernizr() {};Modernizr.prototype = C, Modernizr = new Modernizr(), Modernizr.addTest("svg", !!t.createElementNS && !!t.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect), Modernizr.addTest("picture", "HTMLPictureElement" in e), Modernizr.addTest("svgfilters", function () {
    var t = !1;try {
      t = "SVGFEColorMatrixElement" in e && 2 == SVGFEColorMatrixElement.SVG_FECOLORMATRIX_TYPE_SATURATE;
    } catch (n) {}return t;
  });var x = t.documentElement;Modernizr.addTest("willchange", "willChange" in x.style), Modernizr.addTest("classlist", "classList" in x);var _ = "svg" === x.nodeName.toLowerCase(),
      E = C._config.usePrefixes ? " -webkit- -moz- -o- -ms- ".split(" ") : ["", ""];C._prefixes = E, Modernizr.addTest("csspointerevents", function () {
    var e = s("a").style;return e.cssText = "pointer-events:auto", "auto" === e.pointerEvents;
  }), Modernizr.addTest("srcset", "srcset" in s("img")), Modernizr.addTest("inlinesvg", function () {
    var e = s("div");return e.innerHTML = "<svg/>", "http://www.w3.org/2000/svg" == ("undefined" != typeof SVGRect && e.firstChild && e.firstChild.namespaceURI);
  });var b = function () {
    function e(e, t) {
      var i;return e ? (t && "string" != typeof t || (t = s(t || "div")), e = "on" + e, i = e in t, !i && r && (t.setAttribute || (t = s("div")), t.setAttribute(e, ""), i = "function" == typeof t[e], t[e] !== n && (t[e] = n), t.removeAttribute(e)), i) : !1;
    }var r = !("onblur" in t.documentElement);return e;
  }();C.hasEvent = b;var z = "CSS" in e && "supports" in e.CSS,
      N = "supportsCSS" in e;Modernizr.addTest("supports", z || N);var O = {}.toString;Modernizr.addTest("svgclippaths", function () {
    return !!t.createElementNS && /SVGClipPath/.test(O.call(t.createElementNS("http://www.w3.org/2000/svg", "clipPath")));
  }), Modernizr.addTest("svgforeignobject", function () {
    return !!t.createElementNS && /SVGForeignObject/.test(O.call(t.createElementNS("http://www.w3.org/2000/svg", "foreignObject")));
  }), Modernizr.addTest("smil", function () {
    return !!t.createElementNS && /SVGAnimate/.test(O.call(t.createElementNS("http://www.w3.org/2000/svg", "animate")));
  });var P;!function () {
    var e = {}.hasOwnProperty;P = r(e, "undefined") || r(e.call, "undefined") ? function (e, t) {
      return t in e && r(e.constructor.prototype[t], "undefined");
    } : function (t, n) {
      return e.call(t, n);
    };
  }(), C._l = {}, C.on = function (e, t) {
    this._l[e] || (this._l[e] = []), this._l[e].push(t), Modernizr.hasOwnProperty(e) && setTimeout(function () {
      Modernizr._trigger(e, Modernizr[e]);
    }, 0);
  }, C._trigger = function (e, t) {
    if (this._l[e]) {
      var n = this._l[e];setTimeout(function () {
        var e, r;for (e = 0; e < n.length; e++) {
          (r = n[e])(t);
        }
      }, 0), delete this._l[e];
    }
  }, Modernizr._q.push(function () {
    C.addTest = d;
  }), Modernizr.addAsyncTest(function () {
    var e,
        t,
        n,
        r = s("img"),
        i = "sizes" in r;!i && "srcset" in r ? (t = "data:image/gif;base64,R0lGODlhAgABAPAAAP///wAAACH5BAAAAAAALAAAAAACAAEAAAICBAoAOw==", e = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==", n = function n() {
      d("sizes", 2 == r.width);
    }, r.onload = n, r.onerror = n, r.setAttribute("sizes", "9px"), r.srcset = e + " 1w," + t + " 8w", r.src = e) : d("sizes", i);
  }), Modernizr.addTest("svgasimg", t.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#Image", "1.1"));var I = { elem: s("modernizr") };Modernizr._q.push(function () {
    delete I.elem;
  });var j = { style: I.elem.style };Modernizr._q.unshift(function () {
    delete j.style;
  });var R = C.testStyles = h;Modernizr.addTest("touchevents", function () {
    var n;if ("ontouchstart" in e || e.DocumentTouch && t instanceof DocumentTouch) n = !0;else {
      var r = ["@media (", E.join("touch-enabled),("), "heartz", ")", "{#modernizr{top:9px;position:absolute}}"].join("");R(r, function (e) {
        n = 9 === e.offsetTop;
      });
    }return n;
  }), R("#modernizr { height: 50vh; }", function (t) {
    var n = parseInt(e.innerHeight / 2, 10),
        r = parseInt(a(t, null, "height"), 10);Modernizr.addTest("cssvhunit", r == n);
  }), R("#modernizr1{width: 50vmax}#modernizr2{width:50px;height:50px;overflow:scroll}#modernizr3{position:fixed;top:0;left:0;bottom:0;right:0}", function (e) {
    var t = e.childNodes[2],
        n = e.childNodes[1],
        r = e.childNodes[0],
        i = parseInt((n.offsetWidth - n.clientWidth) / 2, 10),
        o = r.clientWidth / 100,
        s = r.clientHeight / 100,
        u = parseInt(50 * Math.max(o, s), 10),
        f = parseInt(a(t, null, "width"), 10);Modernizr.addTest("cssvmaxunit", l(u, f) || l(u, f - i));
  }, 3), R("#modernizr1{width: 50vm;width:50vmin}#modernizr2{width:50px;height:50px;overflow:scroll}#modernizr3{position:fixed;top:0;left:0;bottom:0;right:0}", function (e) {
    var t = e.childNodes[2],
        n = e.childNodes[1],
        r = e.childNodes[0],
        i = parseInt((n.offsetWidth - n.clientWidth) / 2, 10),
        o = r.clientWidth / 100,
        s = r.clientHeight / 100,
        u = parseInt(50 * Math.min(o, s), 10),
        f = parseInt(a(t, null, "width"), 10);Modernizr.addTest("cssvminunit", l(u, f) || l(u, f - i));
  }, 3), R("#modernizr { width: 50vw; }", function (t) {
    var n = parseInt(e.innerWidth / 2, 10),
        r = parseInt(a(t, null, "width"), 10);Modernizr.addTest("cssvwunit", r == n);
  });var M = (C.testProp = function (e, t, r) {
    return m([e], n, t, r);
  }, "Moz O ms Webkit"),
      L = C._config.usePrefixes ? M.split(" ") : [];C._cssomPrefixes = L;var B = function B(t) {
    var r,
        i = E.length,
        o = e.CSSRule;if ("undefined" == typeof o) return n;if (!t) return !1;if (t = t.replace(/^@/, ""), r = t.replace(/-/g, "_").toUpperCase() + "_RULE", r in o) return "@" + t;for (var s = 0; i > s; s++) {
      var a = E[s],
          l = a.toUpperCase() + "_" + r;if (l in o) return "@-" + a.toLowerCase() + "-" + t;
    }return !1;
  };C.atRule = B;var V = C._config.usePrefixes ? M.toLowerCase().split(" ") : [];C._domPrefixes = V, C.testAllProps = A;var W = C.prefixed = function (e, t, n) {
    return 0 === e.indexOf("@") ? B(e) : (-1 != e.indexOf("-") && (e = f(e)), t ? A(e, t, n) : A(e, "pfx"));
  };Modernizr.addTest("forcetouch", function () {
    return b(W("mouseforcewillbegin", e, !1), e) ? MouseEvent.WEBKIT_FORCE_AT_MOUSE_DOWN && MouseEvent.WEBKIT_FORCE_AT_FORCE_MOUSE_DOWN : !1;
  }), Modernizr.addTest("objectfit", !!W("objectFit"), { aliases: ["object-fit"] }), C.testAllProps = y, Modernizr.addTest("cssfilters", function () {
    if (Modernizr.supports) return y("filter", "blur(2px)");var e = s("a");return e.style.cssText = E.join("filter:blur(2px); "), !!e.style.length && (t.documentMode === n || t.documentMode > 9);
  }), Modernizr.addTest("flexbox", y("flexBasis", "1px", !0)), Modernizr.addTest("flexboxlegacy", y("boxDirection", "reverse", !0)), Modernizr.addTest("flexboxtweener", y("flexAlign", "end", !0)), i(), o(T), delete C.addTest, delete C.addAsyncTest;for (var G = 0; G < Modernizr._q.length; G++) {
    Modernizr._q[G]();
  }e.Modernizr = Modernizr;
}(window, document);

},{}],19:[function(require,module,exports){
'use strict';

(function () {
    if (typeof Modernizr.testProp === 'undefined') {
        return false;
    }

    var properties = ['vectorEffect'];

    function init() {
        for (var i = 0; i < properties.length; i++) {
            testProperty(properties[i]);
        }
    }

    function testProperty(property) {
        if (!property) {
            return false;
        }

        Modernizr.addTest(property.toLowerCase(), function () {
            return Modernizr.testProp(property);
        });
    }

    window.onload = init;
})();

},{}]},{},[5]);
